import axios from 'axios';
import store from '../vuex/store';
import {getToken} from '@/utils/auth';
import Message from 'view-design/src/components/message';
import Model from 'view-design/src/components/modal';

// 创建axios实例
const service = axios.create({
  // baseURL: '/java2api', // api的base_url
  timeout: 35000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(config => {

  // 判断是否要改代理地址
  // if(config.baseURL){
  //   config.url = config.url
  // }

  if (getToken()) {
    let test = config.data;
    if (test) {
      // config.data['access_token']= getToken()
    }

    // if (get('storeId') && 'undefined'!=get('storeId')){
    //   config.headers['storeid'] = get('storeId')
    // }

    config.headers['token'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
  } else {
    config.headers['client_id'] = 'app';
    config.headers['client_secret'] = 'app';
  }
  return config;
}, error => {
  // Do something with request error
  console.log(error); // for debug
  Promise.reject(error);
});

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * code为非200是抛错 可结合自己业务进行修改
     */
    const res = response.data;
    if (res.code !== 200 && res.code !== 412 && !res.access_token) {
      // console.log(res);
      Message.error({
        content: res.msg,
      });

      // 401:未登录;
      if (res.code === 401) {
        Model.info({
          title: '确定登出', content: '您已被登出，请重新登录',
          onOk: () => {
            store.dispatch('signOut').then(() => {
              // location.reload()// 为了重新实例化vue-router对象 避免bug
              window.location.href = '/UserLogin';
            });
          },
          // onCancel: () => {
          //
          // }
        });
      }
      if (res.code === 500) {
        return response.data;
      }

      if (res.code === 501) {
        return response.data;
      }

      if (res.code === 403) {
        return response.data;
      }

      return Promise.reject('error');
    } else {
      return response.data;
    }
  },
  error => {
    Message.error({
      message: error.msg,
    });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/server/request.js